import main from '@/pages/shop/main';
import category from "@/pages/shop/category";
import productPage from "@/pages/shop/productPage";
import shippingPage from "@/pages/shop/shipping";
import payment from "@/pages/shop/payment";
import orderList from "@/pages/shop/orderList";
import orderInfo from "@/pages/shop/orderInfo";
import preOrderList from "@/pages/shop/preOrders";
import preOrderInfo from "@/pages/shop/preOrderInfo";
import searchPage from "@/pages/shop/search";

const routes = [
  {
    path:'/Shop/:catId?',
    component:main,
    meta:{requiredAuth:true}
  },
  {
    path:'/ShopCategory/:catId/:page?',
    component:category,
    meta:{requiredAuth:true}
  },
  {
    path:'/ShopProduct/:id',
    component:productPage,
    meta:{requiredAuth:true}
  },
  {
    path:'/Shipping',
    component:shippingPage,
    meta:{requiredAuth:true}
  },
  {
    path:'/payment/:id',
    component:payment,
    meta:{requiredAuth:true}
  },
  {
    path:'/shopOrder/list',
    component:orderList,
    meta:{requiredAuth:true}
  },
  {
    path:'/shopOrder/View/:id',
    component:orderInfo,
    meta:{requiredAuth:true}
  },
  {
    path:'/shop/PreOrderList',
    component:preOrderList,
    meta:{requiredAuth:true}
  },
  {
    path:'/shop/preOrder/Info/:id',
    component:preOrderInfo,
    meta:{requiredAuth:true}
  },
  {
    path:'/ShopSearch/:page?',
    component:searchPage,
    meta:{requiredAuth:true}
  },
]

export default routes;